import * as React from 'react';

import CurriculumContentContainer from '../../containers/CurriculumContent';
import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import i18n from '../../resources/i18n';
/**
 * カリキュラム詳細内容画面
 * @param props
 */
const CurriculumContent: React.FC<any> = props => {
	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('CurriculumContent_0006')} />
			<CurriculumContentContainer {...props} />
		</>
	);
};

export default CurriculumContent;



// WEBPACK FOOTER //
// ./src/pages/personal/CurriculumContent.tsx